import { i18nLang } from '../../../../../i18n/i18nLang';

export function getFieldKey(data: any, field: any): string {
    const { locale, name } = field || {};
    data = data || {};

    return typeof data[locale] === 'string' && data[locale].trim().length
        ? locale : name;
}

export function setLocaleFieldKeys(data: any[], locale: string): void {
    (data || []).forEach((field: any) => {
        field.locale = `${field.name}${locale !== 'de' ? `_${locale}` : ''}`;
    });
}

export function toggleI18nFields(
    fields: any[], data: any, locale: string, customColumns: string[] = [], callback?: (data: any) => void
): void {
    const curFields: any = {};
    const ignoreFields: any = {};
    const items: any = {};
    const keys: any = {};
    const { languages } = i18nLang || {};
    const suffix: string = locale !== 'de' ? `_${locale}` : '';
    let hiddenColumns: string[] = [];
    let showingColumns: string[] = [];
    data = data || {};
    fields = fields || [];

    fields.forEach((field: any, index: number) => {
        const key: string = (field.key || '').toString();
        items[key] = index;

        if (key.slice(-3)[0] === '_' && languages.indexOf(key.slice(-2)) !== -1) {
            const keyOriginal: string = key.slice(0, -3); // Deutsch -> ohne Suffix

            if ((customColumns || []).indexOf(keyOriginal) !== -1) {
                ignoreFields[keyOriginal] = true;
                ignoreFields[key] = true;
            }
            keys[keyOriginal] = items[keyOriginal];
            keys[key] = index;
        }
    });

    Object.keys(keys).forEach((key: string) => {
        const keyOriginal: string = suffix ? key.slice(0, -3) : key;
        fields[keys[key]].hidden = !(key.slice(-suffix.length) === suffix || (!suffix.length && key.slice(-3)[0] !== '_'));

        if (!fields[keys[key]].hidden) {
            curFields[keyOriginal] = key;
        }

        if (ignoreFields[key]) {
            return;
        }

        if (fields[keys[key]].hidden) {
            hiddenColumns.push(key);
        } else {
            showingColumns.push(key);
            const valueOriginal: string = data[keyOriginal];

            if (suffix && valueOriginal) {
                fields[keys[key]].placeholder = valueOriginal;
            }
        }
    });

    if (typeof callback === 'function') {
        callback({
            curFields,
            hiddenColumns: [...customColumns, ...hiddenColumns],
            showingColumns: showingColumns
        });
    }
}
